import { useCallback, useState } from 'react';

function useRequest() {
  const [isRequesting, setIsRequesting] = useState(false);

  const call = useCallback(async (req: any): Promise<any> => {
    try {
      setIsRequesting(true);
      const data = await req();

      return data;
    } catch (error) {
      throw error;
    } finally {
      setIsRequesting(false);
    }
  }, []);

  return { call, isRequesting };
}
export default useRequest;
